
export const WSREST_TABATA = "https://naosapp.tabata.cloud/saruman/"; //saruman
export const SITE = "NAO";
export const NOME_APP = "DASH";